module.exports = __webpack_public_path__ + "static/media/eCopies.bc1a6854.png";